import { render, staticRenderFns } from "./RemoveCityButton.vue?vue&type=template&id=221395fa&"
import script from "./RemoveCityButton.vue?vue&type=script&lang=js&"
export * from "./RemoveCityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports